// Navigation items for LEPR project

import {
  DashboardIcon,
  HelpCenterIcon,
  MessagesIcon,
  ReportsIcon,
  TaxSettingsIcon,
  TransactionsIcon,
} from '../../components/MainNavigation/icons'
import EPRReportingIcon from '../../components/MainNavigation/icons/EPRReportingIcon'
import { getCombinedSettingsMessageCount } from 'utils/settingsNavBadgeCount'
import { SANDBOX_FEATURE } from '../../helpers/sandboxAccess'
import { PACKAGING_SKU_PATH } from './packagingSkuNav'

/**
 * Get navigation items for LEPR project
 * @param {Object} context - Context object with location, t, newMessagesCount
 * @returns {Array} Array of navigation items
 */
export const getLEPRNavigationItems = (context) => {
  const { location, t, newMessagesCount = {} } = context

  const printMessagesCount = (count) => {
    if (count) {
      return count
    }
    return null
  }

  return [
    {
      url: '/start-guide',
      label: 'Start guide',
      icon: () => <HelpCenterIcon selected={location.pathname.startsWith('/start-guide')} />,
      selected: location.pathname.startsWith('/start-guide'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/home',
      label: t('menu.home'),
      icon: () => <DashboardIcon selected={location.pathname.startsWith('/home')} />,
      selected: location.pathname.startsWith('/home'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/transactions',
      label: t('menu.transactions'),
      icon: () => <TransactionsIcon selected={location.pathname.startsWith('/transactions')} />,
      badge: printMessagesCount(newMessagesCount.transactions),
      selected: location.pathname.startsWith('/transactions'),
      isTaxAgentMainVisible: false,
    },
    {
      url: '/epr-reporting',
      label: 'EPR declarations',
      icon: () => <EPRReportingIcon selected={location.pathname.startsWith('/epr-reporting')} />,
      badge: printMessagesCount(newMessagesCount['epr-report']),
      selected: location.pathname.startsWith('/epr-reporting'),
    },
    {
      url: PACKAGING_SKU_PATH,
      label: t('menu.packagingSku'),
      icon: () => <ReportsIcon selected={location.pathname.startsWith(PACKAGING_SKU_PATH)} />,
      selected: location.pathname.startsWith(PACKAGING_SKU_PATH),
    },
    {
      url: '/messages',
      label: t('menu.messages'),
      icon: () => <MessagesIcon selected={location.pathname.startsWith('/messages')} />,
      badge: printMessagesCount(newMessagesCount.messages),
      selected: location.pathname.startsWith('/messages'),
      sandboxFeature: SANDBOX_FEATURE.MESSAGES,
      isTaxAgentMainVisible: true,
    },
    {
      url: '/settings',
      label: 'SETTINGS',
      icon: () => <TaxSettingsIcon selected={location.pathname.startsWith('/settings')} />,
      badge: printMessagesCount(
        getCombinedSettingsMessageCount(newMessagesCount, 'merchant_settings')
      ),
      selected: location.pathname.startsWith('/settings'),
      isTaxAgentMainVisible: false,
    },
  ]
}
